<!--订单.........-->
<template>
  <el-dialog
    title="订单"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="list-dialog">
    <div>
      <div id="content">
        <div class="tabContent" style="display:block;">
          <!--搜索end-->
          <table class="titleTable">
            <tr>
              <th class="width_200 textLeft">
              </th>
              <th class="width_400 textLeft">订单详情</th>
              <th class="width_200">金额</th>
              <th class="width_200">
                订单状态
              </th>
              <th class="width_200">处理</th>
            </tr>
          </table>
          <!--titleTable end-->
          <div class="orderTable" :style="'height:'+tableHeight(119)+'px'">
            <div class="contentTable" v-for="(item,index) in tableData">
              <div class="head">
                <p class="fl marginR-30 marginL-20">
                  <input type="checkbox" v-model="checkmodel" :value="item.erpserial"/>
                  <label class="color-grey">{{item.htqd||item.adddate}}</label>
                </p>
                <p class="fl marginR-30 alignleft">
                  <span class="color-grey ddNum ">订单号</span>
                  <span class="marginR-30 erpserial1 ">{{item.erpserial}}&nbsp;&nbsp;{{getOrderType(item)}}</span>
                  <a href="javascript:void(0);" style="display: inline-block;" @mouseenter="show1(item)"
                     @mouseleave="hide1(item)">
                    <span
                      class="ellipsis">{{item.status==810||item.status==820? item.pcustomer:item.customername}}</span>
                    <span class="tip "> <img class="iphone_icon" src="/static/img/iphone_icon.jpg"/>
                      <!--提示框-->
                <div class="sub-nav" v-show="item.isShow">
                  <div class="Tipcontent">
                    <ul>
                      <li>联系人：{{item.linkman}}</li>
                      <li>联系电话：{{item.linkmantel}}</li>
                      <li>收货地址：{{item.deliveryaddress}}</li>
                      <li>收货方式：{{item.deliverymode||""}}</li>
                    </ul>
                  </div>
                  <s><i></i></s>
                </div>
                      <!--提示框 end-->
                 </span>
                  </a>
                  <span class="marginR-30 erpserial1" style="margin-left:50px;">{{item.applybydname}}</span>
                  <span>生成铺货单</span><input type="checkbox" @change="changePuHuo($event,item)"/>
                </p>
              </div>
              <!--head end-->
              <table class="mainTable">
                <tr>
                  <td class="width_560"
                      :style="{paddingRight: '0px',paddingLeft: '0px'}"
                      rowspan="2">
                    <div v-for="(item1,index1) in item.jxcformdetailDOList"
                         :style="{height:'70px',paddingTop: '5px',paddingBottom: '5px',borderTop:index1>0?'1px solid #EEEEEE':'none'}">
                      <img style="width:70px;height:70px;margin-left: 10px;" :src="item1.imageUrl||''"
                           @error="imgError"/>
                      <p class="alignleft">
                        <span class="cp_title">{{item1.seedname}}</span>
                        <span>x {{item1.totalnumber||0}}</span>
                      </p>
                      <p style="margin-top: 10px;">
                      <!--<span class="lookDetail color-grey pointer HideButton"-->
                            <!--@click="showSeedDetail(item,item1)">查看详情</span>-->
                      </p>
                    </div>
                  </td>
                  <td class="width_200 textCenter" style="vertical-align: middle;height: 56px" rowspan="2">
                    <div style="" >
                      <p style="">
                        <span class="numtitle textR">金额：</span>
                        <span class="numbody textL" v-if="showlookprice">￥{{( (item.htje||0)+(item.discount||0) ) | numeric(2)}}</span>
                        <span class="numbody textL" v-else>???</span>
                      </p>
                      <p style="">
                        <span class="numtitle textR">运费：</span>
                        <span class="numbody textL">￥{{(item.expressfee||0)|numeric(2)}}<span
                          v-if="roletype=='customerservice'&&item.expressfee>0&&isZongBu()"
                          style="color:Red;cursor:pointer;" title="退运费" @click="tuiYunFei(item)">(退)</span> {{item.deliverymode}}</span>
                      </p>
                      <p style="">
                        <span class="numtitle textR">折扣：</span>
                        <span class="numbody textL" v-if="showlookprice">￥{{(item.discount||0)|numeric(2)}}</span>
                        <span class="numbody textL" v-else>???</span>
                      </p>
                      <p style="">
                        <span class="numtitle textR">实收：</span>
                        <span class="numbody textL" v-if="showlookprice">￥{{(item.yfk||0)|numeric(2)}}</span>
                        <span class="numbody textL" v-else>???</span>
                      </p>
                      <p class="color-yellow" v-if="item.status>100">{{item.paymethod}}</p>
                    </div>
                  </td>
                  <td class="width_200 textCenter" :style="{verticalAlign:roletype=='customerservice'?'middle': 'bottom',height: '56px'}"  :rowspan="roletype=='customerservice'?2:1">
                    <div class="color-yellow"  v-html="getPcustomerInfo(item)"></div>
                    <div class="color-yellow" v-if="roletype!='customerservice'">
                      <div style="height: 24px;">
                    <span class="color-grey pointer HideButton" v-if="isEqualIndependentSerial(item)"
                          @click="showZhuanDan(item)">{{item.buyinfo?"": item.pcustomerserial?'转单':'（修改）'}}</span>
                        <!--<span class="color-grey pointer HideButton"-->
                              <!--v-if="isEqualIndependentSerial(item)&&isZongBu()"-->
                              <!--@click="showChaiDan(item)">{{item.buyinfo?"":'拆单'}}</span>-->
                      </div>
                    </div>
                    <div>
                      <div v-html="getLiuYan(item.remark)"
                           style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
                      <div style="height: 24px;">
                      <span class="pointer color-grey HideButton"
                            @click="showLiuYan(item)">我要留言</span></div>
                    </div>
                  </td>
                  <td rowspan="2" class="width_200 textCenter btnBox">
                    <el-input placeholder="验光配镜单号" size="small" v-model="item.yanguangpeij"
                              style="width: 130px;display: block;margin: auto;" @change="setCusordernum(item)"></el-input>
                    <el-input placeholder="供应商单号" size="small" v-model="item.tracknum"
                              v-if="item.pcustomerserial&&isEqualIndependentSerial(item)&&!item.buyinfo&&!isMachine(item)&&item.status==200"
                              style="width: 130px;display: block;margin: auto;"></el-input>
                    <el-select v-model="item.cangkucode" size="small"
                               v-if="(cangkucaigou(item)||cangkujiagong(item))&&item.status==200"
                               style="width: 130px;display: block;margin: auto;" filterable>
                      <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                                 :label="item.cangkuname"
                                 :value="item.cangkucode">
                      </el-option>
                    </el-select>
                    <template v-if="item.pcustomerserial&&isEqualIndependentSerial(item)&&!item.buyinfo&&!isMachine(item)&&item.status==200">
                      <button   @click="sbuyorder(item)" style="width: 130px;"  :loading="isDisable">发起采购</button>
                      <button   @click="sbuyorderToCus(item)" v-if="ssodirect&&item.ssodirect" style="width: 160px;"  :loading="isDisable"  class="removeButton">发起采购（直发客户）</button>
                    </template>
                    <button v-if="isEqualIndependentSerial(item)&&isHaveStock(item)&&item.status==200"  @click="handleQueRenTongZhiOrMachine(item)" style="width: 130px;">{{getFaHuoTongZhiCangKuText(item)}}</button>
                    <button @click="lookDetails(item)" style="width: 130px;">查看订单</button>
                    <button @click="handlesaleCsagreementToVoid(item)" class="removeButton" v-if='item.yfk==0&&item.htje>0' style="width: 130px;">取消订单</button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!--contentTable end-->
        </div>
        <!--待确认end-->
      </div>

      <CstagreementEditSeedDetail ref="seeddetail" ></CstagreementEditSeedDetail>
      <CstagreementEditChaiDan ref="ChaiDandetail" @bindGrid="bindGridView"></CstagreementEditChaiDan>
      <ExternaldeptChaiDanSel ref="zhuandan"  :unitgroup="3" @select="afterZhuanDan" :title="'选择供应商'"></ExternaldeptChaiDanSel>
      <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGridView"></CstagreementEdit>
      <CstagreementEdit ref="DataContactEditCopy" @bindGrid="bindGridView"></CstagreementEdit>
      <LiuYanEdit ref="liuyan" @afterLiuYan="afterLiuYan"></LiuYanEdit>
      <CstagreementMachiningEdit ref="machiningedit" @bindGrid="bindGridView"></CstagreementMachiningEdit>
      <CstagreementMachiningEdit ref="machiningeditcopy" @bindGrid="bindGridView"></CstagreementMachiningEdit>
      <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
      <BuyfromEssilor ref="BuyfromEssilor" @afterEssilorBuy="afterEssilorBuy" :showTPD="showTPD" :buytype="'buy&sale'"></BuyfromEssilor>
      <StoreEdit ref="StoreEdit"  @bindGrid="bindGridView" @print="lookPrintDetails"></StoreEdit>
    </div>
  </el-dialog>
</template>


<script>
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';
  import {getBySerial} from '@/api/set/externaldept';
  import CstagreementEditSeedDetail from './CstagreementEditSeedDetail'
  import CstagreementEditChaiDan from './CstagreementEditChaiDan'
  import CstagreementEdit from './CstagreementEdit';
  import CstagreementMachiningEdit from './CstagreementMachiningEdit';
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    saveCstagreementData,
    buyoderremove,
    getGroupByCustomerAndPcustomer,
    updatejiagong,
    updategongying,
    comfirefahuo,
    updatecangku,buyodersave,
    kefufaqicaigou,updateaLiRefund,updateYanguangpj
  } from '@/api/set/csagreement';
  import {checkModuleRight} from '@/api/login'
  import {independentDept} from '@/api/set/dept';
  import LiuYanEdit from './LiuYanEdit'
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel'
  import { getRemark} from '@/plugin/ordercommon'
  import {saveData} from '@/api/set/handlelog';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {saveData as saveVoucherDetail} from '@/api/voucher/accountvoucherdetail'  //生成铺货单
  import {login, createOrder,backOrder,urlOrder} from '@/api/ossi';
  import StoreEdit from './StoreEdit';
  import BuyfromEssilor from '@/components/testorder/buyagreement/BuyfromEssilor'

  export default {
    name: 'HsCstagreementList',
    data() {
      return {
        showTPD:true,
        canwriteorder: false,
        userInfoModel: {},
        mySystem:false,
        paramesInfoModel: {},
        printItem: {},
        showgroupguid:'',
        formtype: 42,
        statuses: "",//多个状态，逗号隔开
        status: this.mystatus,
        ssotoken:"",
        website:"",
        fengongscangku:false,
        isreturnorder: -999,//默认不显示isreturnorder=-1的
        id: '',
        fileuname: "",//加工人员
        itemtemp: {},//操作某条记录的临时变量
        isShow: false,
        activeIndex: '100',
        showlookprice: true,//显示价格
        searchContentHeight: 50,
        msg: 'Welcome to Your Vue.js Ap22p',
        dialogFormVisible: false,
        searchdata: "",
        independentserial: "",
        loading: true,
        cangkuname:"",
        categorycode: "",
        categoryname: "",
        seedcode: "",
        seedname: "",
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        searchdatevalue: [],//时间段选择
        isClickEvent: true,//选择供应商、客户清空图标按钮不触发click事件使用
        unitgroup: "",//查询条件的选择供应商或者门店使用
        pcustomer: "",//供应商，仅仅作为显示使用
        pcustomerserial: '',
        customername: '',//门店，仅仅作为显示使用
        customerserial: '',
        cangkucode: '',
        showcancelbtn: false,//显示取消按钮
        fahuotongzhicangkutext: "",//发货通知仓库显示的文本，  可选值：通知仓库、通知加工
        showquerenjiagongbtn: false,//显示确认加工按钮
        showtianxiefahuobtn: false,//显示填写发货单按钮
        ssodirectsend:'',
        ssodirect:false,
        ssodirectbutton:false,
        pagination: {
          currentPage: 1,
          pageSize: 10000,
          total: 0
        },
        tableData: [],
        customerseriallist:[],
        logistics: [],
        checkmodel: [],
        checkedAll: false,
        jxcstoreData: [],
        seedcodes: [],
        couriernumber: '',//快递单号条码
        groupguid: '',
        tracknum: '',//跟踪单号
        isDisable: false,//防止多次提交
        transition:{
          item:{},
          data:[]
        }
      }
    },
    props: {
      mystatus: {
        default: '200'
      },
      roletype: {
        default: "order" //角色菜单信息， 取值：order 、 buy、 store、machining、jiesuan、customerservice 、supply ， 分别对应订单、采购单、库存、加工、结算、客服、供应商利润  等菜单角色
      }
    },
    methods: {
      lookPrintDetails(){
        this.printItem.status = this.printItem.jxcformdetailDOList[0].filltemplate == "50" ? '300' : '350';
        this.lookDetails(this.printItem, 'print')
      },
      //控制仓库权限发起采购、通知加工、通知仓库共用一个仓库下拉框
      cangkucaigou(item) {
        return item.pcustomerserial && this.isEqualIndependentSerial(item) && !item.buyinfo && !this.isMachine(item)
      },
      //控制仓库权限发起采购、通知加工、通知仓库共用一个仓库下拉框
      cangkujiagong(item) {
        return  this.isEqualIndependentSerial(item) && this.isHaveStock(item)
      },
      //处理日志
      handlelog(handlelog) {
        saveData(handlelog).then(response => {
        })
      },
      isEqualApplybydserial(item) {//总部人员只能操作总部管理的门店的订单，加工中心只能操作加工中心管理的门店的订单， 注意跟下面的操作加工中心发货的订单区别
        return this.userInfoModel.independentserial == (item.applybydserial || "")
      },
      isEqualIndependentSerial(item) {//总部人员只能操作总部发货的订单，加工中心只能操作加工中心发货的订单
        return this.userInfoModel.independentserial == (item.independentserial || "")
      },
      isZongBu() {//只有总部人员能操作
        return this.userInfoModel.independentserial == null || this.userInfoModel.independentserial == ""
      },
      //显示 供应商、客户多少个
      showRenderTitle() {
        return this.status != '500' && this.status != '750' && this.status != '820' && this.status != 'all'
      },
      //铺货事件
      changePuHuo(event, item) {
        if (event.target.checked) {//生成铺货单
          this.$confirm("是否确定生成铺货单？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.createPuHuo(event, item)
          }).catch(() => {
            this.$message({
              type: 'info',
              duration: 1500,
              message: '已取消'
            });
            event.target.checked = false
          });
        }
      },
      //生成铺货单
      createPuHuo(event, item) {
        let tempform = {}
        let temparr = [item.erpserial]
        tempform.hetongserial='none'
        tempform.customerserial = item.customerserial
        tempform.customername = item.customername
        tempform.applybydserial = item.applybydserial
        tempform.applybydname = item.applybydname
        tempform.independentserial = item.applybydserial
        if (item.htje >= 0) {
          tempform.accountname = "出货铺货"
          tempform.debit = item.htje
        } else {
          tempform.accountname = "退货铺货"
          tempform.credit = item.htje//负数
          tempform.debit = Math.abs(item.htje) //正数
        }
        tempform.tenantid = JSON.stringify(temparr)//临时存储
        let date1 = new Date()
        tempform.accdate = date1.getFullYear() + "-" + (date1.getMonth() + 1 + '').padLeft(2, '0') + "-" + (date1.getDate() + '').padLeft(2, '0')
        //构建备注内容
        var remark = '';
        if (item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
          for (let j in item.jxcformdetailDOList) {
            var newRow = item.jxcformdetailDOList[j];
            remark += (remark == '' ? '' : '，') + "〖" + newRow.erpserial + "〗" + newRow.seedname + ":计" + Math.abs(newRow.totalnumber) + (newRow.packagesize && newRow.packagesize.indexOf('"X"') > -1 ? "片" : "副") + "，共" + (newRow.totalmoneytax || 0) + "元"
          }
        }
        tempform.remark = remark;
        saveVoucherDetail(tempform).then((response) => {
          if (response.data.code == 0) {
            event.target.disabled = true
            this.$message({
              type: 'success',
              duration: 1500,
              message: '已成功生成铺货单'
            })
          } else {
            this.$message({
              type: 'error',
              duration: 1500,
              message: response.data.msg
            })
            event.target.checked = false
          }
        })
      },
      show1: function (item) {
        item.isShow = true
      },
      hide1: function (item) {
        item.isShow = false
      },
      //加工单、销售单、退货单
      getOrderType(item) {
        if (item.formtype == 42) {
          if (item.parentguid) {
            return '退货单'
          } else {
            if (item && item.jxcformdetailDOList.length > 0) {
              for (let i in item.jxcformdetailDOList) {
                if (item.jxcformdetailDOList[i].filltemplate == "50") {
                  return '加工单'
                }
              }
            }
          }
          return '销售单'
        }
        return ""
      },
      //判断此订单的订单明细中是否存在备货的，如果有一个是备货就可以显示通知仓库
      isHaveStock(item) {
        if (item && item.jxcformdetailDOList.length > 0) {
          for (let i in item.jxcformdetailDOList) {
            if (item.jxcformdetailDOList[i].filltemplate == "50" || item.jxcformdetailDOList[i].nostock == 1) {//在其余条件的基础上，如果是加工，肯定显示
              return true
            }
          }

          var ts = this.userInfoModel.thirdstore;
          if (this.userInfoModel.zhaoyanjcustomer && item.pcustomerserial && item.pcustomerserial == this.userInfoModel.zhaoyanjcustomer && ts && ts.length > 0) {

            for (let i in item.jxcformdetailDOList) {
              var hasValue=false;
              for(let j in ts){
                if((";"+ts[j].ids+";").indexOf(";"+item.jxcformdetailDOList[i].seedcode+";")>-1){
                  hasValue=true;//产品在第三方仓库中
                }
              }
              if(!hasValue)//只要有一个商品不存在 不允许通知第三方仓库
                return false;
            }
            item["thirdstore"]=true;
            return true

          }
        }
        return false
      },
      //判断此订单的订单明细中是否存在不备货的，如果有一个是不备货且不是加工（filltemplate!=50）的就可以显示发起采购
      isHaveNoStock(item) {
        if (item && item.jxcformdetailDOList.length > 0) {
          for (let i in item.jxcformdetailDOList) {
            if (item.jxcformdetailDOList[i].nostock == -1 && item.jxcformdetailDOList[i].filltemplate != '50') {
              return true
            }
          }
        }
        return false
      },
      setCusordernum(item) {
        updateYanguangpj({
          liuyan: item.yanguangpeij,
          unitguid: item.unitguid,
        }).then(response => {
          if (response.data.code == 0) {
            item.remark = response.data.remark
          }
        });
      },
      //是否加工单
      isMachine(item) {
        if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
          if (item.jxcformdetailDOList[0].filltemplate == "50") {
            return true
          }
        }
        return false
      },
      //发货通知仓库的按钮的文本
      getFaHuoTongZhiCangKuText(item) {
        let text1 = "通知仓库"
        if (this.isMachine(item)) {
          text1 = "通知加工"
        }
        return text1
      },
      showSeedDetail(item, itemdetail) {
        if (this.showlookcaigoubtn) {//采购
          if (itemdetail.filltemplate == "30") {
            this.$refs.buyseeddetail.show()
            this.$refs.buyseeddetail.initData(item.unitguid, itemdetail.seedcode, itemdetail.seedname, "", itemdetail.filltemplate)
          } else {
            this.$refs.buyseeddetail.show()
            this.$refs.buyseeddetail.initData(item.unitguid, itemdetail.seedcode, itemdetail.seedname)
          }
        } else {
          if (itemdetail.filltemplate == "20") {//定制片
            this.$refs.DataContactEdit.initData(item, "", itemdetail.groupguid, itemdetail.seedcode)
            this.OpenDialog()
          } else if (itemdetail.filltemplate == "50") {//加工
            this.$refs.machiningedit.initData(item)
            this.$refs.machiningedit.show()
          }
          else if (itemdetail.filltemplate == "10") {//现片 单条明细
            this.$refs.seeddetail.show()
            this.$refs.seeddetail.initData(item.unitguid, itemdetail.seedcode, item.erpserial)
          } else if (itemdetail.filltemplate == "30") {//数量选择 单条明细
            this.$refs.seeddetail.show()
            this.$refs.seeddetail.initData(item.unitguid, itemdetail.seedcode, "", item.filltemplate)
          } else {//数量选择、特殊加工
            this.$refs.DataContactEdit.initData(item,)
            this.OpenDialog()
          }
        }
      },
      lookDetailsCopy(row) {
        this.$refs.DataContactEditCopy.initData(row)
        this.$refs.DataContactEditCopy.show()
      },
      lookDetails(row,roletype) {
        if (row.jxcformdetailDOList[0].filltemplate == "50") {
          this.$refs.machiningedit.initData(row)
          this.$refs.machiningedit.show(roletype)
        } else {
          this.$refs.DataContactEdit.initData(row)
          this.OpenDialog()
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      showLiuYan(item, opmsg, status) {//留言
        this.$refs.liuyan.show(item, opmsg, status)
      },
      afterLiuYan(remark, unitguid, status, erpserial) {//留言
          this.tableData.forEach(item => {
            if (item.unitguid == unitguid) {
              item.remark = remark;
            }
          })
      },
      //取消订单
      handlesaleCsagreementToVoid(row) {
        this.$confirm('是否确定作废?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          cstagreementUpdateData({groupguid: row.groupguid, status: row.status, isStauts: '200'}).then(response => {
            if (response.data.code == 0) {
              this.$message({
                duration: 1500,
                type: 'success',
                message: '操作成功!'
              });
            this.bindGrid(row.groupguid)
             } else {
              this.$message.error('操作失败')
            }
          })
        }).catch(() => {
          this.$message({
            duration: 1500,
            type: 'info',
            message: '已取消作废'
          });
        });


      },
      //确认步骤通知仓库或者通知加工按钮
      handleQueRenTongZhiOrMachine(item) {
        this.printItem = item;
        let biaoji = "store"
        if (this.isMachine(item)) {
          biaoji = "machining"
        }
        if (biaoji == "store") {
          //通知仓库
          item.biaoji = "store"
          this.$refs.StoreEdit.initData(item, -1, 'medium-dialog');
        } else {//通知加工
          this.$refs.StoreEdit.initData(item, 1, 'mini-dialog')
        }
      },
      sbuyorderToCus(item){
        this.ssodirectbutton=true;
        this.sbuyorderbegin(item);
      },
      sbuyorder(item) {
        this.ssodirectbutton=false;
        this.sbuyorderbegin(item);
      },
      //发起采购
      sbuyorderbegin(item) {
        this.isDisable = true
        this.cangkuname = ''
        var ckInfo = {};
        for (let i = 0; i < this.jxcstoreData.length; i++) {
          if (item.cangkucode == this.jxcstoreData[i].cangkucode) {
            this.cangkuname = this.jxcstoreData[i].cangkuname;
            ckInfo = this.jxcstoreData[i];
          }
        }

        if (!item.cangkucode) {
          this.$message({
            message: '请选择仓库',
            type: 'error'
          })
          this.isDisable = false
          return
        }

        //向供应商发起采购
        this.ssotoken = "";
        kefufaqicaigou({
          erpserial: item.erpserial,
          unitguid: item.unitguid,
          pcustomerserial: item.pcustomerserial,
          pcustomer: item.pcustomer,
          customerserial: item.customerserial,
          deliveryaddress: item.deliveryaddress,
          linkman: item.linkman,
          linkmantel: item.linkmantel,
          tracknum: item.tracknum,
          cangkucode: item.cangkucode,
          cangkuname: this.cangkuname,
          invoicesource: 1,
          seedinfo: item.seedinfo
        }).then((response) => {
          this.ssodirectsend='';
          if (response.data.ssocode && response.data.ssocode.indexOf("supplier") > -1) {//直接向供应商采购
            this.ssotoken = response.data.ssocode;
            this.ssobuydetail = response.data.ssobuydetail;
            item.cangkuname = this.cangkuname;
            this.transition.item=item
            this.transition.data=response.data
            this.$refs.BuyfromEssilor.show(this.ssotoken, this.ssobuydetail, item);
          } else if (response.data.ssocode) {
            //执行登录方法
            this.mySystem=response.data.usesso == '2';
            login({idencode: response.data.ssocode, tenantid: this.userInfoModel.tenantid},this.mySystem).then(loginres => {
              if (loginres.data.code == 0) {
                this.ssotoken = loginres.data.msg;
                this.website = loginres.data.website;
                if (response.data.iddirectsend && response.data.iddirectsend == 1) {//直发客户
                  this.ssodirectsend = {
                    "weburl": urlOrder(),
                    "expressfee": item.expressfee,
                    "customername": item.customername,
                    "deliveryaddress": item.deliveryaddress,
                    "linkman": item.linkman,
                    "linkmantel": item.linkmantel,
                    "deliverymode": item.deliverymode,
                    "tenantid": item.tenantid,
                    "erpserial": item.erpserial,
                  };
                }else{
                  if (this.ssotoken.indexOf('http') > -1) {
                    this.ssodirectsend = {
                      linkman: ckInfo.applyby, linkmantel: ckInfo.tel, deliveryaddress: ckInfo.adressdetail
                    };
                  }
                }
                this.postSSO(item, ckInfo, response.data);
              } else {
                this.$message({message: loginres.data.msg, type: 'error'});
                this.isDisable = false;
              }
            });
          } else {
            if (this.paramesInfoModel.other.oddrequired == 'true') {
              if (!item.tracknum) {
                this.$message({
                  message: '请填写跟踪单号',
                  type: 'error'
                })
                this.isDisable = false
                return
              }
            }
            if (item.tracknum)
              item.tracknum = item.tracknum.trim();

            this.daixiadBuy(item, response.data, '采购单保存成功！', null);
          }
        });
      },
      afterEssilorBuy(buyInfo) {
        this.daixiadBuy(this.transition.item, this.transition.data, '提交成功！', buyInfo);
      },
      postSSO(item,ckInfo,data) {//推送给供应商
        var remarkend = '{"msg":"' + item.erpserial + '","date":"","uname":"客户单号","type":"客户留言"}';
        var buyRemark = '[' + remarkend + ']';
        if (item.remark && item.remark != '[]') {
          buyRemark = '[' + remarkend + ',' + item.remark.substr(1);
        }
        createOrder({
          parentguid: item.erpserial,
          uname: this.userInfoModel.uname,
          uguid: this.userInfoModel.uguid,
          customerserial: item.customerserial,
          customername: item.customername,
          linkman: ckInfo.applyby,
          linkmantel: ckInfo.tel,
          deliveryaddress: ckInfo.adressdetail,
          deliverymode: '配送',
          formproperty: data.ssobuydetail,
          remark: buyRemark,
          ssodirectsend: this.ssodirectsend && this.ssodirectbutton ? JSON.stringify(this.ssodirectsend) : "",//存供应商直发信息
        }, this.ssotoken,this.mySystem).then(response => {
          if(response.data.price) {
            // var priceList = response.data.price;//{商品编码:价格} 只有一个商品
            // var buyItems = JSON.parse(data.jxcforms);
            // for (let j in buyItems) {
            //   buyItems[j].gysprice = priceList[buyItems[j].seedcode]
            // }
            // data.jxcforms = JSON.stringify(buyItems);
          }
          if(data.map) {
            var jsonMap = JSON.parse(data.map);
            jsonMap.tracknum = response.data.erpserial
            data.map = JSON.stringify(jsonMap);
          }

          if (response.data.code == 0) {
            this.daixiadBuy(item, data, '上游订单已生成，供应商单号：' + response.data.erpserial,null);
          } else {
            if (response.data.groupguid) {//打开支付页面
              this.$confirm(response.data.msg, '提示', {
                confirmButtonText: '生成订单并支付',
                cancelButtonText: '暂不生成',
                showClose:false,
                type: 'warning'
              }).then(() => {
                this.$refs.BuyfromSupplyer.show(this.ssotoken, this.website, response.data, 'pay');
                this.daixiadBuy(item,data, '上游订单已生成，供应商单号：' +response.data.erpserial+'，请尽快完成支付！',null);
              }).catch(() => {
                //撤销订单
                backOrder({erpserial:response.data.erpserial.split(';')[0]}, this.ssotoken,this.mySystem).then(resDel =>{
                  this.isDisable = false
                });
              });
            } else {
              this.$message({
                message: response.data.msg ? response.data.msg : '提交的商品不存在！',
                type: 'error'
              })
              this.isDisable = false
            }
          }
        });
      },
      daixiadBuy(item,data,msg,supplydetail) {
        buyodersave({
          jxcforms: data.jxcforms,
          map: data.map,
          cstagreements: data.cstagreements,
          supplydetail: supplydetail
        }).then(response => {
          if (response.data.obj) {
            this.$message({
              message: msg,
              type: 'success'
            })

            var totalnumber = 0;
            var itemsD=JSON.parse(data.jxcforms);
            for (let i in itemsD) {
              totalnumber += itemsD[i].num;
            }
            var handlelog = {}
            handlelog.erpserial = item.erpserial
            handlelog.isopen = 1
            handlelog.insub = 1
            handlelog.casestepname = '以销定采'
            handlelog.totalnumber = totalnumber
            if (item.cangkuname) {
              handlelog.remark = '入' + item.cangkuname
            }
            this.handlelog(handlelog);//保存处理日志
            this.bindGrid(item.groupguid)
          } else {
            this.$message({
              message: '采购失败',
              type: 'error'
            })
            this.isDisable = false
          }
        })
      },
      showZhuanDan(item) {
        this.seedcodes = []
        this.itemtemp = item
        for (let i = 0; i < item.jxcformdetailDOList.length; i++) {
          this.seedcodes.push(item.jxcformdetailDOList[i]["seedcode"])
        }
        this.$refs.zhuandan.initData(this.seedcodes)
        this.$refs.zhuandan.show()
      },
      showChaiDan(item) {
        this.$refs.ChaiDandetail.initData(item)
        this.$refs.ChaiDandetail.show()
      },
      afterZhuanDan(customerserial, customername, row) {
        updategongying({
          unitguid: this.itemtemp.unitguid,
          pcustomerserial: customerserial,
          pcustomer: customername
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              duration: 1500,
              type: 'success',
              message: '操作成功!'
            });
            this.itemtemp.pcustomerserial = customerserial
            this.itemtemp.pcustomer = customername
            this.externaldeptinfo(customerserial,'buy',this.itemtemp);
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      externaldeptinfo(customerserial,typename,row) {
        if (row)
          row.ssodirect = false;
        var cus = this.customerseriallist.find((v) => {
          return v.customerserial == customerserial;
        });
        if (cus != null) {
          if (typename == 'buy') {
            if (row && (cus.obj.usesso == 1 || cus.obj.usesso == 2) && cus.obj.ssocode) {
              row.ssodirect = true;
            }
          } else if (typename == 'sale') {
            if (cus.obj.iddirectsend == 1) {
              this.ssodirect = true;
            }
          }
          return;
        }

        cus = {customerserial: customerserial, obj: null}
        this.customerseriallist.push(cus);
        getBySerial({customerserial: customerserial}).then(resCus => {
          if (resCus.data.code == 0 && resCus.data.obj) {
            cus.obj = resCus.data.obj;
            if (typename == 'sale' && resCus.data.obj.iddirectsend == 1) {
              this.ssodirect = true;
            } else if (typename == 'buy') {
              if ((cus.obj.usesso == 1 || cus.obj.usesso == 2) && cus.obj.ssocode) {
                row.ssodirect = true;
              }
            }
          }
        });

      },
      getPcustomerInfo(item) {
        let result = "";
        if (item.pcustomerserial) {
          result = this.roletype == "customerservice" ? "" : "<span style='color:black;'>" + item.pcustomer + "</span>"
          if (item.buyinfo) {
            let temp = JSON.parse(item.buyinfo)
            if (temp.status == "810") {
              result += "<span style='color:black;'>采购中</span>"
            } else if (temp.status == "820") {
              result += "<span style='color:black;'>采购已完成</span>"
            }
          }
        } else {
          result = '待确认供应商'
        }
        return result
      },
      bindGridView(){
        this.bindGrid(this.showgroupguid);
      },
      bindGrid(groupguid) {
        this.ssodirect = false;
        this.showgroupguid = groupguid;
        this.cusandptbyind();
        this.dialogFormVisible = true;
        this.tableData = []
        getCstagreementListDataNew({
          needtuihuoinfo: "0",
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          statuses: 200,//this.statuses,这个页面只显示待确认的订单
          formtype: this.formtype,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          independentserial: 'all',
          customerserial: this.customerserial,
          pcustomerserial: this.pcustomerserial,
          needdetail: "1",
          isshowbuyinfo: "0",
          isshowtuihuofrombuy: "0",
          neefahuoinfo: "0",
          isreturnorder: -999,
          fileuname: this.fileuname,
          groupguid: groupguid,

        }).then(response => {
          this.tableData = response.data.obj.rows
          if (this.tableData.length == 0) {
            this.dialogFormVisible = false
          } else {
            this.externaldeptinfo(this.tableData[0].customerserial, 'sale');
          }
          var initCangKu = this.tableData[0].applybydserial;
          var showcangkucode = '';
          if (this.jxcstoreData.length > 0) {
            showcangkucode = this.jxcstoreData[0].cangkucode;
            if(this.fengongscangku) {
              for (let i in this.jxcstoreData) {
                if (this.jxcstoreData[i].independentserial == initCangKu) {
                  showcangkucode = this.jxcstoreData[i].cangkucode;
                  break;
                }
              }
            }
          }

          for (let i = 0; i < this.tableData.length; i++) {
            this.$set(this.tableData[i], "isShow", false)
            this.$set(this.tableData[i], "ssodirect", false)
            this.$set(this.tableData[i], "yanguangpeij", "")
            this.tableData[i].cangkucode = showcangkucode;
            if (this.tableData[i].pcustomerserial) {
              this.externaldeptinfo(this.tableData[i].pcustomerserial, 'buy', this.tableData[i]);
            }
          }
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
        });
      },
      //根据登录人过滤仓库
      cusandptbyind() {
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }
          }
        })
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
    },
    mounted() {

      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      if (this.userInfoModel.myright.indexOf('|查看订单价格|') != -1) {
        this.showlookprice = true;
      } else {
        this.showlookprice = false;
      }
      checkModuleRight({name: 'fengongscangku'}).then(reponse => {
        this.fengongscangku = reponse.data.code == 0;
      });
      this.paramesInfoModel = JSON.parse(localStorage.getItem("hpapi_parames"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;

    },
    watch: {},
    components: {
      CstagreementEditSeedDetail,
      CstagreementEditChaiDan,
      ExternaldeptChaiDanSel,
      CstagreementEdit,
      CstagreementMachiningEdit,
      LiuYanEdit,
      BuyfromSupplyer,
      BuyfromEssilor,
      StoreEdit
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @import '../../../../static/css/clear.css';
  @import '../../../../static/css/index.css';

  .orderTable {
    overflow: auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/HsCstagreementList.vue